import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import TermsSection from "./TermsSection"
import CTASignUpLong from "./CTASignUpLong"
import Footer from "@components/Footer"
import "./index.scss"
import "@styles/global.scss"

const PrivacyPolicy = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <TermsSection></TermsSection>
          <CTASignUpLong />
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
